import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/exchange/[micCode]/ExchangeDetailClient.tsx");
